import CheckComponent from '@/components/Check/Check.vue';
import VerticalLineComponent from '@/components/VerticalLine/VerticalLine.vue';

export default {
  name: 'StepsComponent',
  props: ['stepsTitles', 'subtitlesSteps', 'currentStep'],
  components: {
    CheckComponent,
    VerticalLineComponent,
  },
  data() {
    return {
      stepsQuantity: this.$props.stepsTitles.length,
    };
  },
};
